import { getAuthAxiosBackend } from "@/helpers/axios"

class BodyMainPartsServices {

    getByGovernorateId(id) {
        return getAuthAxiosBackend().get('' + id.toString())
    }

    get(id) {
        return getAuthAxiosBackend().get('BodyMainParts/getBodyMainPartsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('BodyMainParts/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('BodyMainParts/addBodyMainParts', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('BodyMainParts/updateBodyMainParts/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('BodyMainParts/restoreBodyMainParts' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('BodyMainParts/softDeleteBodyMainParts/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('BodyMainParts/deleteBodyMainParts/' + id.toString())
    }
}

export default new BodyMainPartsServices()
